import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Palette, Monitor, Megaphone, BookOpen, Brush, Play, Bot, Code, Box } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PremiumServiceCard } from '@/components/PremiumServiceCard';
import { Service } from '@/lib/api';

interface ServicesGridProps {
  services: Service[];
}

const ServicesGrid = ({ services }: ServicesGridProps) => {
  const serviceIcons = {
    "Branding & Identidade Visual": Palette,
    "UI/UX Design": Monitor,
    "Direção de Arte & Campanhas": Megaphone,
    "Design Editorial": BookOpen,
    "Ilustração & Arte Digital": Brush,
    "Motion Graphics & Vídeo": Play,
    "IA & Personagens Digitais": Bot,
    "Desenvolvimento Fullstack": Code,
    "Modelagem 3D Não-Orgânica": Box
  };

  return (
    <div className="w-full">
      <div className="text-center mb-16">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-white">
          Como posso ajudar seu projeto
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto text-lg">
          Serviços especializados em design visual e estratégia criativa para marcas que querem impactar
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {services.map((service, index) => {
          const Icon = serviceIcons[service.name as keyof typeof serviceIcons] || Palette;

          return (
            <PremiumServiceCard
              key={service.id}
              index={index}
              title={service.name}
              description={service.summary}
              price={service.startingPrice || "Sob consulta"}
              icon={Icon}
              deliverables={service.deliverables}
              linkTo="/servicos"
            />
          );
        })}
      </div>

      <div className="text-center">
        <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 h-12 text-lg transition-all duration-300 hover:scale-105">
          <Link to="/servicos" className="flex items-center">
            Ver todos os serviços
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ServicesGrid;
